// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"2f879cbc","341":"d04918e4","438":"a3d103c0","706":"dba2c915","726":"e2d51770","901":"22ed253e"}[chunkId] + ".chunk.js";
};